/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect} from 'react'

const DriverHistory = (props) => {
    // auth
    var CryptoJS = require("crypto-js");

    // boolean for toggling the screen
    const [ historyGate, steHistoryGate ] = useState(false)

    // content for this component
    const [ content, setContent ] = useState(null)

    // state for displaying
    const [ complianceArray, setComplianceArray ] = useState([])
    const [ rentalVanArray, setRentalVanArray ] = useState([])

    // grab the props and map the data
    useEffect( () => {
        if (props.selectedDriver) {
            // get list of vans and registration
            async function getData(url = '') {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'GET', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    });

                return response ? response.json() : console.log('no reponse')
            };
            if (props.selectedDriver.Compliance_Van) {
                // function to grab all iterations of the list
                // takes the next uuid, and array of registrations
                const awaitAllResponses = async function (nextUuid) {

                    // make a fragment
                    const fragment = await getData(`https://backendpajamas.herokuapp.com/compliancevan/${nextUuid}/`)

                    // if there is a next entry
                    if (fragment.next) {
                        // return the array with the async function added on
                        return [fragment, (await awaitAllResponses(fragment.next))].flat()
                    } else {
                        // return the data
                        return [fragment]
                    }

                }
                awaitAllResponses(props.selectedDriver.Compliance_Van).then( response => {
                    // sort them by assighned date
                    response.sort((a, b) => (new Date(a.Assighned_Date) > new Date(b.Assighned_Date) ? -1 : 1))

                    // set data to state for render
                    setComplianceArray(response.map( ele => {
                    return (
                        <div>
                            <h3>Assighned: {ele.Assighned_Date}</h3>
                            <h3>Returned: {ele.Returned_Date ? ele.Returned_Date : 'Still In Use'}</h3>
                            <h3>Registration: {ele.vehicle_Id}</h3>
                            <hr />
                        </div>
                    )
                }))
                    setRentalVanArray(props.selectedDriver.vehicle_list.map( ele => <h3>{ele}</h3>))
                })

            }
        }
    }, [props])

    // function for toggling the history screen
    const handleClick = () => {
        historyGate ? steHistoryGate(false) : steHistoryGate(true)
    }

    // toggle the screen
    useEffect( () => {
        if (historyGate) {
            setContent(
                <div className='historyFullScreen'>
                    <div className='listsContainer'>
                        <div className='listsInside'>
                            <h2>Compliance History</h2>
                            {complianceArray}
                        </div>
                        <div className='listsInside'>
                            <h2>Rental Van History</h2>
                            {rentalVanArray}
                        </div>
                        <div 
                            className='viewDriverHistoryTwo'
                            onClick={handleClick}
                        >
                            Return
                        </div>
                    </div>
                </div>
            )
        }
        else {
            setContent(
                <div 
                    className='viewDriverHistory'
                    onClick={handleClick}
                >
                    Van History
                </div>
            )
        }

    }, [historyGate])
    
    
    return (
        <>
            {content}
        </>
    )
}

export default DriverHistory